/**
 * @generated SignedSource<<3a41a9a935e4ecf88c0f52c914c3a392>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type StreamAutoRecordAutomationConfigQuery$variables = {
  streamID: string;
};
export type StreamAutoRecordAutomationConfigQuery$data = {
  readonly node: {
    readonly autoRecordSetting?: {
      readonly __typename: "NoteStreamStreamBasedAutoRecordSource";
      readonly creator: {
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly value: boolean;
    } | {
      readonly __typename: "NoteStreamUserSettingsBasedAutoRecordEnableSource";
      readonly cannotBeRecordedReason: string | null;
      readonly rules: ReadonlyArray<{
        readonly autoRecordRuleUsers: ReadonlyArray<{
          readonly user: {
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
          };
        }>;
        readonly ruleLevel: AutoRecordRuleLevel;
      }>;
      readonly users: ReadonlyArray<{
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
      }>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_stream">;
  } | null;
};
export type StreamAutoRecordAutomationConfigQuery = {
  response: StreamAutoRecordAutomationConfigQuery$data;
  variables: StreamAutoRecordAutomationConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleLevel",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cannotBeRecordedReason",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isViewer",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamAutoRecordAutomationConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_stream"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autoRecordSetting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "NoteStreamStreamBasedAutoRecordSource",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "users",
                        "plural": true,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoRecordRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AutoRecordRuleUser",
                            "kind": "LinkedField",
                            "name": "autoRecordRuleUsers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamAutoRecordAutomationConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autoRecordSetting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "NoteStreamStreamBasedAutoRecordSource",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "users",
                        "plural": true,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoRecordRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AutoRecordRuleUser",
                            "kind": "LinkedField",
                            "name": "autoRecordRuleUsers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2abfd22cb43ae136fde5ec2e5bae9ede",
    "id": null,
    "metadata": {},
    "name": "StreamAutoRecordAutomationConfigQuery",
    "operationKind": "query",
    "text": "query StreamAutoRecordAutomationConfigQuery(\n  $streamID: ID!\n) {\n  node(id: $streamID) {\n    __typename\n    ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n    ... on NoteStream {\n      id\n      autoRecordSetting {\n        __typename\n        ... on NoteStreamStreamBasedAutoRecordSource {\n          value\n          creator {\n            id\n            firstName\n            fullName\n          }\n        }\n        ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n          users {\n            id\n            firstName\n            fullName\n          }\n          rules {\n            ruleLevel\n            autoRecordRuleUsers {\n              user {\n                id\n                firstName\n                fullName\n              }\n            }\n            id\n          }\n          cannotBeRecordedReason\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_stream on NoteStream {\n  autoRecordSetting {\n    __typename\n    ... on NoteStreamStreamBasedAutoRecordSource {\n      value\n      creator {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n    }\n    ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n      users {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n      rules {\n        ruleLevel\n        autoRecordRuleUsers {\n          user {\n            id\n            firstName\n            fullName\n            isViewer\n          }\n        }\n        id\n      }\n      cannotBeRecordedReason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "46444cca9eb09339ebc7a62df465c37e";

export default node;
